export const constants = {
  isDevice: undefined,
  namespace: undefined,
  pageEntranceFinished: true
};

export const instances = {
  scroll: undefined
};
